import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";
import { useParams } from "react-router-dom";
import * as XLSX from "xlsx";

const Resultados = () => {
  let { id } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `https://portaltransaccionalback.azurewebsites.net/api/ObtenerResultados?principal=${id}`
        );
        const result = await response.json();
        setData(result);
      } catch (error) {
        console.error("Error al obtener los datos:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const exportToExcel = () => {
    const formattedData = data.map((item) => ({
      ID: item.id,
      "Nombre Completo": item.nombreCompleto,
      Identificación: item.identificacion,
      Celular: item.celular,
      Correo: item.correo,
      Empresa: item.empresa,
      Ciudad: item.ciudad,
      Estado: item.estado,
      País: item.pais,
      Título: item.titulo,
      "Línea de Servicio": item.descripcion,
      "Tipo de Documento": item.tematica || "N/A",
      Dinámicos: item.opciones
        .map((opcion) => `${opcion.nombreCampo}: ${opcion.respuesta}`)
        .join(", "),
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Resultados");

    XLSX.writeFile(workbook, `resultados_${id}.xlsx`);
  };

  return (
    <div className="container">
      <div className="text-center">
        <div className="container-fluid">
          <div
            className="card shadow mb-4"
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
              padding: "20px",
              width: "85%",
              margin: "0 auto",
            }}
          >
            <div className="card-header py-3">
              <Typography variant="h5" align="center" gutterBottom>
                Información Ingresada
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={exportToExcel}
                style={{ marginBottom: "20px" }}
              >
                Descargar Excel
              </Button>
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "20px 0",
                  }}
                >
                  <CircularProgress />
                </div>
              ) : data.length === 0 ? (
                <Typography
                  variant="body1"
                  align="center"
                  style={{ margin: "20px 0" }}
                >
                  No hay información disponible.
                </Typography>
              ) : (
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>ID</TableCell>
                        <TableCell>Nombre Completo</TableCell>
                        <TableCell>Identificación</TableCell>
                        <TableCell>Celular</TableCell>
                        <TableCell>Correo</TableCell>
                        <TableCell>Empresa</TableCell>
                        <TableCell>Ciudad</TableCell>
                        <TableCell>Estado</TableCell>
                        <TableCell>País</TableCell>
                        <TableCell>Título</TableCell>
                        <TableCell>Línea de Servicio</TableCell>
                        <TableCell>Tipo de Documento</TableCell>
                        <TableCell>Canal</TableCell>
                        <TableCell>Dinámicos</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {data.map((item) => (
                        <TableRow key={item.id}>
                          <TableCell>{item.id}</TableCell>
                          <TableCell>{item.nombreCompleto}</TableCell>
                          <TableCell>{item.identificacion}</TableCell>
                          <TableCell>{item.celular}</TableCell>
                          <TableCell>{item.correo}</TableCell>
                          <TableCell>{item.empresa}</TableCell>
                          <TableCell>{item.ciudad}</TableCell>
                          <TableCell>{item.estado}</TableCell>
                          <TableCell>{item.pais}</TableCell>
                          <TableCell>{item.titulo}</TableCell>
                          <TableCell>{item.descripcion}</TableCell>
                          <TableCell>{item.tematica || "N/A"}</TableCell>
                          <TableCell>{item.canal || ""}</TableCell>
                          <TableCell>
                            {item.opciones.map((opcion, index) => (
                              <div key={index}>
                                <strong>{opcion.nombreCampo}:</strong>{" "}
                                {opcion.respuesta}
                              </div>
                            ))}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Resultados;
